import React from 'react';

import { DialogBodyProps } from './DialogBody.types';

export const DialogBody: React.FC<DialogBodyProps> = ({ children, className }) => (
  <div data-testid="dialog-content" className={className}>
    {children}
  </div>
);
